import React from 'react'

/**
 * Matches an ECS amount inside a modal message, e.g. "1.62 ECS".
 *
 * "ECS" is a literal token in every locale — en/ru/ja/zh/ar all interpolate
 * `{{cost}} ECS` — so this one pattern covers all of them. Punctuation is left
 * out on purpose: en/ru/ar end the sentence with "." while ja/zh use "。", so
 * matching it would highlight inconsistently across languages.
 */
const ECS_AMOUNT = /(\d[\d.,]*\s*ECS)/gi

/**
 * Splits a modal message so the ECS cost can be coloured apart from the
 * sentence — the cost is what the player is actually deciding on.
 *
 * The message is a plain string (every caller passes one), so this happens at
 * render time rather than by reworking the call sites.
 */
export const highlightCost = (message: string, className: string): React.ReactNode =>
  // split() with a capturing group leaves the matches at the odd indices.
  // Testing each part with ECS_AMOUNT instead would be a bug: it is /g, and a
  // global regex carries a stateful lastIndex across .test() calls.
  message.split(ECS_AMOUNT).map((part, index) =>
    index % 2 === 1 ? (
      <b key={index} className={className}>
        {part}
      </b>
    ) : (
      part
    ),
  )
